import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

/** 컨베이어 트랙 레이아웃 상수 */
const ITEM_SIZE_PX = 92
const ITEM_GAP_PX = 28
const ITEM_COUNT = 6
/** 한 세트(6개) 너비 — 애니메이션이 이 거리만큼 이동 후 리셋 */
const ONE_SET_PX = ITEM_COUNT * (ITEM_SIZE_PX + ITEM_GAP_PX)
const CONVEYOR_DURATION_S = 12

const scroll = keyframes`
  from { transform: translateX(-${ONE_SET_PX}px); }
  to { transform: translateX(0); }
`

export const ConveyorContainer = styled.div`
  position: relative;
  width: 100%;
`

/** overflow: hidden은 컨베이어 트랙 스크롤에만 적용 — 번개/플밍이는 밖에 배치해야 잘리지 않음 */
export const ConveyorWrapper = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
`

/** conveyor-belt.png 원본 크기 — 로드 전 높이 예약(aspect-ratio)에 사용. 이미지 교체 시 함께 갱신 */
const BELT_IMAGE_WIDTH_PX = 780
const BELT_IMAGE_HEIGHT_PX = 436

export const BeltBackground = styled.img`
  display: block;
  width: 100%;
  height: auto;
  /* 이미지 로드 전 높이 예약 — 없으면 로드 완료 시 하단 콘텐츠(CTA)가 내려앉는 레이아웃 시프트 발생 */
  aspect-ratio: ${BELT_IMAGE_WIDTH_PX} / ${BELT_IMAGE_HEIGHT_PX};
  margin-top: -35px;
`

export const ConveyorTrack = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDisabled',
})<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${ITEM_GAP_PX}px;
  width: max-content;
  will-change: transform;
  backface-visibility: hidden;
  animation: ${scroll} ${CONVEYOR_DURATION_S}s linear infinite;
  animation-play-state: ${({ isDisabled }) => (isDisabled ? 'paused' : 'running')};

  img {
    transform: translateZ(0);
    width: ${ITEM_SIZE_PX}px;
    height: 84px;
    object-fit: contain;
    flex-shrink: 0;
  }
`

/** 히어로 영역 (플밍이 + 번개) 레이아웃 상수 */
const HERO_WIDTH_PX = 338
const FLOAT_DURATION_S = 3
const FLOAT_DISTANCE_PX = 6

/** 번개용 둥둥 애니메이션 — var(--rotate)로 각 번개의 회전 각도를 유지하면서 위아래 이동 */
const float = keyframes`
  0%, 100% { transform: translate(0, 0) rotate(var(--rotate)); }
  50% { transform: translate(0, -${FLOAT_DISTANCE_PX}px) rotate(var(--rotate)); }
`

/** 반짝이/플밍이용 둥둥 애니메이션 — 회전 없이 위아래만 */
const floatSparkle = keyframes`
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(0, -${FLOAT_DISTANCE_PX}px); }
`

export const HeroMainImageBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${HERO_WIDTH_PX}px;
  margin: 0 auto 16px;
  will-change: transform;
`

export const LightIcon = styled.img<{ left: number; top: number; size: number; rotate: number; delay?: number }>`
  position: absolute;
  left: ${({ left }) => (left / HERO_WIDTH_PX) * 100}%;
  top: ${({ top }) => top}px;
  width: ${({ size }) => size}px;
  height: auto;
  --rotate: ${({ rotate }) => rotate}deg;
  transform: rotate(var(--rotate));
  animation: ${float} ${FLOAT_DURATION_S}s ease-in-out ${({ delay = 0 }) => delay}s infinite backwards;
  pointer-events: none;
`

export const SparkleIcon = styled.img<{ left: number; top: number; delay?: number }>`
  position: absolute;
  left: ${({ left }) => (left / HERO_WIDTH_PX) * 100}%;
  top: ${({ top }) => top}px;
  width: 12px;
  height: 12px;
  animation: ${floatSparkle} ${FLOAT_DURATION_S}s ease-in-out ${({ delay = 0 }) => delay}s infinite;
  pointer-events: none;
`

export const PlmingImage = styled.img`
  animation: ${floatSparkle} ${FLOAT_DURATION_S}s ease-in-out infinite;
`

export const DisabledPlmingImage = styled.img`
  width: ${HERO_WIDTH_PX}px;
  height: 120px;
  object-fit: contain;
`
